import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex } from 'pcln-design-system'
import { validateFlexDateContainerRT } from '../../../util/get-qualified-flex-dates'
import FlexDateTile from '../FlexDateTile'

export const FlexDates = styled(Flex)`
  flex-direction: row;
  overflow-x: auto;
  ${(props) =>
    !props.isSlimDesign &&
    `${props.theme.flyQueries.tablet} {
      flex-direction: column;
    }`}
`

class FlexResponsiveContainer extends Component {
  onSuggestedFlexDateClick = (url, position, e) => {
    e.preventDefault()
    window.open(url, '_blank')
    if (this.props.isDesktop) {
      this.props.flyGaLogic.fire.suggestedFlexDates(this.props.dates.length === 3, this.props.dates.length)
    }
  }

  render() {
    const { minimumRetailPrice, dates, searchOrigin, searchDestination, isSlimDesign } = this.props

    const items = dates.map((itinerary, index) => {
      const {
        retailAltPriceDiff,
        formatDepartDate,
        formatReturnDate,
        lengthOfStayText,
        newSearchUrl,
        formatDepartDay,
        formatReturnDay,
      } = validateFlexDateContainerRT(itinerary, minimumRetailPrice, searchOrigin, searchDestination)

      const displayStopsInfo = itinerary.numStops === 0

      return (
        <FlexDateTile
          key={index}
          priceDiff={retailAltPriceDiff}
          returnDate={formatReturnDate}
          departDate={formatDepartDate}
          lengthOfStay={lengthOfStayText}
          flexDatePrice={Math.ceil(itinerary.fare)}
          flexDateSearchUrl={newSearchUrl}
          navigateToFlexDateUrl={this.onSuggestedFlexDateClick}
          position={index + 1}
          returnDay={formatReturnDay}
          departDay={formatDepartDay}
          displayStopsInfo={displayStopsInfo}
          isSlimDesign={isSlimDesign}
        />
      )
    })

    return (
      <FlexDates isSlimDesign={isSlimDesign} p={isSlimDesign ? [1, 1, 0, 0, 0] : [1, 1, 1, 1, 1]}>
        {items}
      </FlexDates>
    )
  }
}

FlexResponsiveContainer.defaultProps = {
  dates: [],
}

FlexResponsiveContainer.propTypes = {
  minimumRetailPrice: PropTypes.number,
  dates: PropTypes.array,
  flyGaLogic: PropTypes.object,
  searchOrigin: PropTypes.string,
  searchDestination: PropTypes.string,
  isDesktop: PropTypes.bool,
  isSlimDesign: PropTypes.bool,
}

export default FlexResponsiveContainer
